import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';

export default class PaSubscriptionMetaInfo extends Model {
  [Type] = 'pa-subscription-meta-info' as const;

  @attr('dayjs') declare lastRecommendationsRefresh: DayjsTransformReturn;
  // Also used as id (primaryKey in the model serializer)
  @attr('number') declare subscriptionId: number;
}
